/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import PopoverWithArrow from "../components/ui/PopoverWithArrow";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
  TextField,
  Tooltip,
  Button,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tab,
  FormLabel,
  InputBase,
  FormControl,
  AlertTitle,
  Popover,
  Avatar,
  ListItemIcon,
  ListItemText,
  Divider,
  Autocomplete,
  ListItem,
  ListItemAvatar,
  Backdrop,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import SearchIcon from "@mui/icons-material/Search";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import FolderCopyOutlinedIcon from "@mui/icons-material/FolderCopyOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import { HelpOutline } from "@mui/icons-material";
import { dataGridRowSpacing } from "../data/constants";

const rows = [
  {
    id: 1,
    name: "Document 1 Document 1",
    type: "PDF",
    createdBy: "Alice",
    avatar: "https://i.pravatar.cc/150?img=1",
    createdDate: "2024-12-01",
    tag: "Work",
    size: "1.2 MB",
  },
  {
    id: 2,
    name: "Image 1",
    type: "JPG",
    createdBy: "Bob",
    avatar: "https://i.pravatar.cc/150?img=2",
    createdDate: "2024-11-28",
    tag: "Personal",
    size: "500 KB",
  },
  {
    id: 3,
    name: "Presentation 1",
    type: "PPT",
    createdBy: "Alice",
    avatar: "https://i.pravatar.cc/150?img=3",
    createdDate: "2024-11-15",
    tag: "Work",
    size: "2.5 MB",
  },
  {
    id: 4,
    name: "Spreadsheet 1",
    type: "XLS",
    createdBy: "Charlie",
    avatar: "https://i.pravatar.cc/150?img=4",
    createdDate: "2024-11-10",
    tag: "Finance",
    size: "1.1 MB",
  },
  {
    id: 5,
    name: "Image 2",
    type: "PNG",
    createdBy: "David",
    avatar: "https://i.pravatar.cc/150?img=5",
    createdDate: "2024-10-25",
    tag: "Personal",
    size: "300 KB",
  },
  {
    id: 6,
    name: "Document 1",
    type: "PDF",
    createdBy: "Alice",
    avatar: "https://i.pravatar.cc/150?img=1",
    createdDate: "2024-12-01",
    tag: "Work",
    size: "1.2 MB",
  },
  {
    id: 7,
    name: "Image 1",
    type: "JPG",
    createdBy: "Bob",
    avatar: "https://i.pravatar.cc/150?img=2",
    createdDate: "2024-11-28",
    tag: "Personal",
    size: "500 KB",
  },
  {
    id: 8,
    name: "Presentation 1",
    type: "PPT",
    createdBy: "Alice",
    avatar: "https://i.pravatar.cc/150?img=3",
    createdDate: "2024-11-15",
    tag: "Work",
    size: "2.5 MB",
  },
  {
    id: 9,
    name: "Spreadsheet 1",
    type: "XLS",
    createdBy: "Charlie",
    avatar: "https://i.pravatar.cc/150?img=4",
    createdDate: "2024-11-10",
    tag: "Finance",
    size: "1.1 MB",
  },
  {
    id: 10,
    name: "Image 2",
    type: "PNG",
    createdBy: "David",
    avatar: "https://i.pravatar.cc/150?img=5",
    createdDate: "2024-10-25",
    tag: "Personal",
    size: "300 KB",
  },
];

//Basic table grid
function basicGridCreateData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number
) {
  return { name, calories, fat, carbs, protein };
}

//Temporary data created for testing.
const basicGridRows = [
  basicGridCreateData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  basicGridCreateData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  basicGridCreateData("Eclair", 262, 16.0, 24, 6.0),
  basicGridCreateData("Cupcake", 305, 3.7, 67, 4.3),
  basicGridCreateData("Gingerbread", 356, 16.0, 49, 3.9),
];

// Example user data with email and image (if available)
const users = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    imageUrl: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  { id: 2, name: "Jane Smith", email: "jane@example.com", imageUrl: "" }, // No image
  {
    id: 3,
    name: "Alice Johnson",
    email: "alice@example.com",
    imageUrl: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    id: 4,
    name: "Abigail Doe",
    email: "john@example.com",
    imageUrl: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  { id: 5, name: "Penelope Smith", email: "jane@example.com", imageUrl: "" }, // No image
  {
    id: 6,
    name: "Sonia Johnson",
    email: "alice@example.com",
    imageUrl: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    id: 7,
    name: "Tracey Doe",
    email: "john@example.com",
    imageUrl: "https://randomuser.me/api/portraits/men/1.jpg",
  },
  { id: 8, name: "Victoria Smith", email: "jane@example.com", imageUrl: "" }, // No image
  {
    id: 9,
    name: "Wendy Johnson",
    email: "alice@example.com",
    imageUrl: "https://randomuser.me/api/portraits/women/1.jpg",
  },
];

// Function to generate background color based on the name
const getAvatarBackgroundColor = (name: string) => {
  const colors = ["#ff5722", "#2196f3", "#4caf50", "#ff9800", "#9c27b0"];
  const index = name.charCodeAt(0) % colors.length;
  return colors[index];
};

export default function UiComponent() {
  const [value1, setValue1] = React.useState("1");
  const [value2, setValue2] = React.useState("1");
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openConfirmation, setOpenopenConfirmation] = React.useState(false);
  const [selectedUsers, setSelectedUsers] = useState<
    { id: number; name: string; email: string; imageUrl?: string }[]
  >([]);
  const [message, setMessage] = useState("");
  const [fileLink] = useState("https://yourapp.com/shared-file-link");
  const openPopover = Boolean(anchorEl);

  const [openLoading, setOpenLoading] = React.useState(false);
  const handleLoadingClose = () => {
    setOpenLoading(false);
  };
  const handleLoadingOpen = () => {
    setOpenLoading(true);
  };

  //Popover
  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  //tabs
  const handleChange1 = (event: React.SyntheticEvent, newValue: string) => {
    setValue1(newValue);
  };

  const handleChange2 = (event: React.SyntheticEvent, newValue: string) => {
    setValue2(newValue);
  };

  //dialog
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  //action dialog
  const [openActionDialog, setOpenActionDialog] = React.useState(false);

  const handleOpenActionDialog = () => {
    setOpenActionDialog(true);
  };
  const handleCloseActionDialog = () => {
    setOpenActionDialog(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(fileLink);
    alert("Link copied to clipboard!");
  };

  const handleShare = () => {
    console.log("Sharing with:", selectedUsers, "Message:", message);
    // Implement API call for sharing logic
    handleClose();
  };

  //Snackbar
  const handleSnackbarClose = () => setSnackbarOpen(false);

  //OTP input
  const handleOtpChange = (newValue: string) => {
    setOtp(newValue);
  };

  // Confirmation dialog
  const handleClickConfirmationOpen = () => {
    setOpenopenConfirmation(true);
  };

  const handleConfirmationClose = () => {
    setOpenopenConfirmation(false);
  };

  // Function to render SVG icons
  const renderSvgIcon = (type: string) => {
    switch (type) {
      case "PDF":
        return <img src="/folder.svg" alt="PDF Icon" style={{ width: 20, height: 20 }} />;
      case "JPG":
        return <img src="/image.svg" alt="JPG Icon" style={{ width: 20, height: 20 }} />;
      case "PPT":
        return <img src="/excel.svg" alt="PPT Icon" style={{ width: 20, height: 20 }} />;
      case "XLS":
        return <img src="/video-doc.svg" alt="XLS Icon" style={{ width: 20, height: 20 }} />;
      case "PNG":
        return <img src="/word.svg" alt="PNG Icon" style={{ width: 20, height: 20 }} />;
      default:
        return null;
    }
  };

  // action menu
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  // grid
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {renderSvgIcon(params.row.type)}
          <span style={{ marginLeft: 8 }}>{params.value}</span>
        </div>
      ),
    },
    { field: "type", headerName: "Type", flex: 1 },

    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar src={params.row.avatar} alt={params.value} style={{ marginRight: 8 }} />
          {params.value}
        </div>
      ),
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
      minWidth: 150,
    },
    { field: "tag", headerName: "Tag", flex: 1 },
    { field: "size", headerName: "Size", flex: 1 },
    {
      field: "action",
      headerName: "Actions",
      width: 100,
      renderCell: () => (
        <>
          <IconButton onClick={(event) => handleMenuOpen(event)}>
            <MoreVertIcon />
          </IconButton>
        </>
      ),
    },
  ];
  const paginationModel = { page: 0, pageSize: 10 };

  return (
    <Box sx={{ p: 0 }}>
      {/* Table */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Table
          </Typography>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{ pagination: { paginationModel } }}
            checkboxSelection
            disableRowSelectionOnClick
            disableColumnSelector={true}
            getRowSpacing={() => ({
              top: dataGridRowSpacing,
            })}
          />

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
            sx={{
              "& .MuiPaper-root": {
                width: "200px", // Set the desired width
              },
            }}
          >
            <MenuItem>
              <ListItemIcon>
                <FileDownloadOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Download</ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <BorderColorOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Edit</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleOpenActionDialog}>
              <ListItemIcon>
                <ShareOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Share</ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <ContentCopyOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Make a copy</ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <FolderCopyOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Subfolder</ListItemText>
            </MenuItem>
            <MenuItem>
              <ListItemIcon>
                <UploadFileOutlinedIcon />
              </ListItemIcon>
              <ListItemText>File upload</ListItemText>
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />
            <MenuItem>
              <ListItemIcon>
                <DeleteOutlinedIcon />
              </ListItemIcon>
              <ListItemText>Move to bin</ListItemText>
            </MenuItem>
          </Menu>

          {/* Share Dialog */}
          <Dialog open={openActionDialog} onClose={handleCloseActionDialog} fullWidth maxWidth="sm">
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Avatar
                src="/folder.svg"
                alt="file type"
                sx={{ width: 40, height: 40, background: "#fff", p: "7px" }}
              ></Avatar>
              Share File
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleCloseActionDialog}
              sx={() => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: "#fff",
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              {/* Select Users */}
              <Autocomplete
                multiple
                options={users}
                getOptionLabel={(option) => option.name}
                value={selectedUsers}
                onChange={(event, newValue) => setSelectedUsers(newValue)}
                sx={{
                  ".MuiAutocomplete-tag": {
                    maxHeight: "80px", // Adjust height as needed
                    overflowY: "auto",
                  },
                }}
                renderOption={(props, option) => (
                  <li {...props}>
                    <ListItem sx={{ p: "0px" }}>
                      <ListItemAvatar>
                        <Avatar
                          src={option.imageUrl || ""}
                          style={{
                            backgroundColor: option.imageUrl
                              ? undefined
                              : getAvatarBackgroundColor(option.name),
                          }}
                        >
                          {!option.imageUrl && option.name[0]} {/* Show initial if no image */}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={option.name} secondary={option.email} />
                    </ListItem>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Add an email or name" />
                )}
              />
              <Alert severity="error" sx={{ mt: "8px" }}>
                <AlertTitle>
                  Sorry the users list below will not be able to access this content as they dont
                  have permission.{" "}
                </AlertTitle>
                1. Johnd <br></br> 2. DJohn <br></br>
                <Typography sx={{ mt: 1, mb: 0 }} variant="body2">
                  Kindly remove these names to proceed.
                </Typography>
              </Alert>
              {/* Copy Link Section */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              ></div>

              {/* Message Field */}
              <TextField
                multiline
                rows={3}
                fullWidth
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                style={{ marginTop: "10px" }}
                variant="outlined"
                placeholder="Add a message"
              />
            </DialogContent>

            <DialogActions>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<InsertLinkOutlinedIcon />}
                  onClick={handleCopyLink}
                >
                  Copy link
                </Button>

                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button onClick={handleCloseActionDialog} variant="contained" color="light">
                    Cancel
                  </Button>
                  <Button onClick={handleShare} variant="contained" color="primary">
                    Share
                  </Button>
                </Box>
              </Box>
            </DialogActions>
          </Dialog>
        </CardContent>
      </Card>

      {/* Tabs */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Tabs
          </Typography>

          <Box sx={{ width: "100%", typography: "body1", mb: 4 }}>
            <TabContext value={value1}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleChange1} aria-label="First Tab Set">
                  <Tab label="Item One" value="1" />
                  <Tab label="Item Two" value="2" />
                  <Tab label="Item Three" value="3" />
                </TabList>
              </Box>
              <TabPanel value="1">First Set - Item One</TabPanel>
              <TabPanel value="2">First Set - Item Two</TabPanel>
              <TabPanel value="3">First Set - Item Three</TabPanel>
            </TabContext>
          </Box>
        </CardContent>
      </Card>

      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Card Tabs
          </Typography>

          <Box sx={{ width: "100%", typography: "body1" }} className="card-tabs">
            <TabContext value={value2}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleChange2}
                  aria-label="Second Tab Set"
                  sx={{
                    "& .MuiTabs-indicator": { display: "none" },
                    height: "32px",
                  }}
                >
                  <Tab label="Item A" value="1" sx={{ height: "32px" }} />
                  <Tab label="Item B" value="2" />
                  <Tab label="Item C" value="3" />
                </TabList>
              </Box>
              <TabPanel value="1">Second Set - Item A</TabPanel>
              <TabPanel value="2">Second Set - Item B</TabPanel>
              <TabPanel value="3">Second Set - Item C</TabPanel>
            </TabContext>
          </Box>
        </CardContent>
      </Card>

      {/* Error Block */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Error Block
          </Typography>

          <Box>
            <FormControl>
              <TextField
                id=""
                type=""
                name=""
                placeholder="Invite others by name or email"
                autoComplete=""
                required
                fullWidth
                variant="outlined"
                margin="normal"
                size="small"
              />
              <Alert severity="error">
                <AlertTitle>
                  Sorry the users list below will not be able to access this content as they dont
                  have permission.{" "}
                </AlertTitle>
                1. Johnd <br></br> 2. DJohn <br></br>
                <Typography sx={{ mt: 1, mb: 0 }} variant="body2">
                  Kindly remove these names to proceed.
                </Typography>
              </Alert>
            </FormControl>
          </Box>
        </CardContent>
      </Card>

      {/* Search Input */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Search Input
          </Typography>
          <Paper
            component="form"
            sx={{
              p: "0px 0px",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
              width: 400,
            }}
            variant="outlined"
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search"
              inputProps={{ "aria-label": "search google maps" }}
            />
            <Button variant="contained" sx={{ width: "55px", minWidth: "55px" }}>
              <SearchIcon />
            </Button>
          </Paper>
        </CardContent>
      </Card>

      {/* Tooltip on a Control */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Tooltip on a Control
          </Typography>
          <Tooltip title="This is a tooltip" arrow>
            <Button variant="contained">Hover me</Button>
          </Tooltip>
        </CardContent>
      </Card>

      {/* Auto Insert Values */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Auto Insert Values
          </Typography>
          <Alert severity="error" sx={{ mb: "5px" }}>
            Too many failed attempts, Your account has been locked, please try again later or
            contact your HR Coordinator.
          </Alert>
          <MuiOtpInput value={otp} onChange={handleOtpChange} sx={{ width: 380 }} length={6} />
          <Box
            sx={{
              width: 380,
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button variant="contained" color="light">
              Clear
            </Button>
            <Button variant="contained">Get OTP</Button>
          </Box>
        </CardContent>
      </Card>

      {/* Sticky tooltip(popover) */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Sticky tooltip(popover)
          </Typography>
          <Button variant="contained" onClick={handleOpenPopover}>
            Open Popover
          </Button>
          <Popover
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <div className="p-3">
              <Typography variant="h1" component="h1" className="mb-3">
                This is a Heading
              </Typography>
              This is some content inside the popover.
            </div>
          </Popover>
          <PopoverWithArrow
            icon={<HelpOutline sx={{ fontSize: "26px" }} />}
            htmlContent="<h6>Lorem Ipsum is simply dummy text</h6><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br> Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>"
            placement="bottom"
            iconColor="#333333"
          />
        </CardContent>
      </Card>

      {/* Sticky tooltip(popover) */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Confirmation
          </Typography>
          <Button variant="contained" onClick={handleClickConfirmationOpen}>
            Confirmation dialog
          </Button>
          <Dialog
            open={openConfirmation}
            onClose={handleConfirmationClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">
              {"Do you want to publish this folder?"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleConfirmationClose}
              sx={() => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: "#fff",
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Typography gutterBottom variant="body2">
                Let Google help apps determine location. This means sending anonymous location data
                to Google, even when no apps are running.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleConfirmationClose} color="light" variant="contained">
                No
              </Button>
              <Button onClick={handleConfirmationClose} autoFocus variant="contained">
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </CardContent>
      </Card>

      {/* Multiline Textbox */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Multiline Textbox
          </Typography>
          <FormLabel>Multiline</FormLabel>
          <TextField
            id="outlined-multiline-static"
            multiline
            variant="outlined"
            rows={4}
            fullWidth
            placeholder="Type here"
          />
        </CardContent>
      </Card>

      {/* Footer Note */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Footer Note
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ fontSize: "13px" }}>
            This is a footer note with additional information for the user.
          </Typography>
        </CardContent>
      </Card>

      {/* Confirmation/Warning/Error Message */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Warning/Error Message
          </Typography>
          <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
            Show Snackbar
          </Button>
          <Snackbar
            open={snackbarOpen}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
          >
            <Alert onClose={handleSnackbarClose} severity="warning">
              This is a warning message.
            </Alert>
          </Snackbar>
        </CardContent>
      </Card>

      {/* Lightbox */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Lightbox
          </Typography>
          <Button variant="contained" onClick={handleClickOpen}>
            Open dialog
          </Button>
          <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title">Modal title</DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={() => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: "#fff",
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent dividers>
              <Typography gutterBottom variant="body2">
                Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac
                facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac,
                vestibulum at eros.
              </Typography>
              <Typography gutterBottom variant="body2">
                Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis
                lacus vel augue laoreet rutrum faucibus dolor auctor.
              </Typography>
              <Typography gutterBottom variant="body2">
                Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel
                scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non
                metus auctor fringilla.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button autoFocus variant="contained" color="light" onClick={handleClose}>
                Close
              </Button>
              <Button autoFocus variant="contained" onClick={handleClose}>
                Save changes
              </Button>
            </DialogActions>
          </Dialog>
        </CardContent>
      </Card>

      {/* Page loading */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Page loading
          </Typography>
          <Button onClick={handleLoadingOpen} variant="contained">
            Show backdrop
          </Button>
          <Backdrop
            sx={(theme) => ({
              zIndex: theme.zIndex.drawer + 1,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            })}
            open={openLoading}
            onClick={handleLoadingClose}
            className="custom-backdrop"
          >
            <Box component="img" src="/loading-logo.gif" alt="logo-icon" />
            <Typography variant="h6">Loading...</Typography>
          </Backdrop>
        </CardContent>
      </Card>

      {/* Basic table */}
      <Card className="mb-3">
        <CardContent>
          <Typography variant="h1" component="div" className="mb-3">
            Basic table
          </Typography>

          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Dessert (100g serving)</TableCell>
                <TableCell align="right">Calories</TableCell>
                <TableCell align="right">Fat&nbsp;(g)</TableCell>
                <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                <TableCell align="right">Protein&nbsp;(g)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {basicGridRows.map((row) => (
                <TableRow key={row.name}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">{row.calories}</TableCell>
                  <TableCell align="right">{row.fat}</TableCell>
                  <TableCell align="right">{row.carbs}</TableCell>
                  <TableCell align="right">{row.protein}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
}
